import { Getter } from '../Getter';
import { HttpError } from '../HttpError';
import URI from 'urijs';
import { ApiAccount } from './Models/ApiAccount';
import { Account } from './Models/Account';
import { idForProvider } from 'utils/providerHelpers';

type ApiResponse = ApiAccount | null | undefined;

interface DataResponse {
  data?: Account;
  error?: never;
}

interface ErrorResponse {
  data?: never;
  error: HttpError;
}

export type ClientOutput = DataResponse | ErrorResponse;

export class AccountClient {
  private getter: Getter<ApiResponse | HttpError>;

  constructor(getter: Getter<ApiResponse | HttpError>) {
    this.getter = getter;
  }

  public async retrieveAsync(): Promise<ClientOutput> {
    const response = await this.tryRetrieveAsync();

    if (!response) {
      return {
        data: undefined,
        error: undefined,
      };
    }

    if (response instanceof HttpError) {
      return {
        error: response,
      };
    }

    const organizations = response.organizations.map((org) => ({
      ...org,
      providerId: idForProvider(org.provider),
      isMetricsOnly:
        Boolean(org.products.metrics?.enabled) &&
        !org.products.code_review.enabled,
    }));

    // TODO: Map entirety of ApiAccount entries to camel case (Account)
    return {
      data: {
        user: response.user,
        organizations,
        userStorage: response.user_storage,
      },
    };
  }

  private async tryRetrieveAsync(): Promise<ApiResponse | HttpError> {
    const href = this.getHref();
    return await this.getter.get(href);
  }

  public getHref(): string {
    return URI('/api/v1/account').toString();
  }
}
